import log from 'salvo-lite/log'

class CartCount {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        document.addEventListener('cartItemAdded', e => {
            const cart = e.detail.data
            this._elem.classList.add('items-in-cart')
            this._elem.querySelector('span').textContent = cart.item_count
        })
    }
}

export default CartCount



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CartCount.js